import {createSlice} from '@reduxjs/toolkit';

// ---- import from local actions ----
import {fetchUserPermissions} from './../actions/AccessActions';


const AccessSlice = createSlice({
  name: 'access',
  initialState: {
    userPermissions: '[]',
    status: 'idle',
    error: '',
    loading: false,
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchUserPermissions.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUserPermissions.fulfilled, (state, action) => {
        state.status = 'idle';
        state.userPermissions = JSON.stringify(action.payload.result);
      })
      .addCase(fetchUserPermissions.rejected, (state, action) => {
        state.status = 'rejected';
        state.error = action.error.message;
      });
  },
});


export default AccessSlice.reducer;
